// extracted by mini-css-extract-plugin
export default {"greenBadge":"logs_greenBadge__vWgOb","infoBadge":"logs_infoBadge__H84Lx","dangerBadge":"logs_dangerBadge__ev6Ek"};